import { useAuthStore } from 'cloak-auth/src/Client/stores';

export function useHasNext() {
    const decodedToken = useAuthStore((state) => state.decodedToken);
    const hasNext = decodedToken?.realm_access.roles.includes('next');
    return hasNext;
}
